// removed by extract-text-webpack-plugin
module.exports = {"legend_container":"legend_container__3-oBe","legend_item":"legend_item__i-Csa","capacity_legend_block":"capacity_legend_block__2Z9wk","knowledge_legend_block":"knowledge_legend_block__3Eu1R","partnership_legend_block":"partnership_legend_block__2E8dK","legend_text":"legend_text__3DxIq","partnership_text":"partnership_text__13r__","knowledge_text":"knowledge_text__1c8bx","capacity_text":"capacity_text__113Jw"};


//////////////////
// WEBPACK FOOTER
// ./components/sscMarkerlegend/style.scss
// module id = 2cq4
// module chunks = 0